import React from "react";
import { SideMenu, DateRangePicker } from "./../../components";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import "./dispute.css";
import { useNavigate } from "react-router-dom";
import { BsFillChatDotsFill } from "react-icons/bs";
let Dispute = () => {
  const navigate = useNavigate();
  let TableData = [
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Panding",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Resolved",
      action: "In Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "unread",
      status: "acknowledge",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Panding",
      action: "Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "Read",
      status: "Resolved",
      action: "In Active",
    },
    {
      title: "posuere nulla pharetra",
      discount: "20%",
      country: "burnside",
      location: "Lorem ipsum dolor sit a...",
      adminStatus: "unread",
      status: "acknowledge",
      action: "Active",
    },
  ];
  const ActionHandler = (e, status) => {
    if (e.target.value === "View") {
      navigate("/dispute/view", { state: { status: status } });
    }
  };
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={10} lg={10} md={10} sm={6} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-button" variant="text">
                <p className="page-header-button-text">Download</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Search by booking</p>
                <input
                  type="text"
                  className="header-input"
                  placeholder="Search by booking"
                />
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={3} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">Admin status</p>
                <select className="header-dropdown">
                  <option value="All">All</option>
                  <option value="Read">Read</option>
                  <option value="Unread">Unread</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={2} lg={2} md={3} sm={12} xs={12}>
              <div>
                <p className="header-input-heading">dispute Status</p>
                <select className="header-dropdown">
                  <option value="All">All</option>
                  <option value="Panding">Panding</option>
                  <option value="Resolved">Resolved</option>
                  <option value="acknowledge">acknowledge</option>
                </select>
              </div>
            </Grid>
            <Grid item xl={3} lg={3} md={3} sm={6} xs={12}>
              <DateRangePicker />
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={6} xs={12}>
              <Button className="header-apply-button" variant="text">
                <p className="header-apply-button-text">Apply</p>
              </Button>
            </Grid>
          </Grid>
        </Box>
        <br />
        <div className="table-container">
          <div className="table-data-container">
            <table>
              <thead>
              <tr>
                <th className="disput-table-id-heading">ID</th>
                <th className="disput-table-booking-heading">Booking</th>
                <th className="disput-table-create-date-heading">
                  Create date
                </th>
                <th className="disput-table-description-heading">
                  Discription
                </th>
                <th className="disput-table-dispute-status-heading">
                  dispute Status
                </th>
                <th className="disput-table-dispute-chat-heading">Chat</th>
                <th className="disput-table-dispute-action-heading"></th>
              </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tr key={tableIndex}>
                    <td className="table-id-data">{tableIndex + 1}</td>
                    <td className="table-data">posuere nulla pharetra</td>
                    <td className="table-data">JAN 4, 2022</td>
                    <td className="table-data">Lorem ipsum dolor sit a...</td>
                    <td className="table-data">
                      <div
                        className="table-data--button"
                        style={{
                          backgroundColor:
                            tableValue.status === "Panding"
                              ? "#FFD1B0"
                              : tableValue.status === "acknowledge"
                              ? "#E0E0E0"
                              : "#D2FFEB",
                        }}
                      >
                        <p
                          className="table-data--button-title"
                          style={{
                            color:
                              tableValue.status === "Panding"
                                ? "#B84D00"
                                : tableValue.status === "acknowledge"
                                ? "#4F4F4F"
                                : "#098B51",
                          }}
                        >
                          {tableValue.status}
                        </p>
                      </div>
                    </td>
                    <td className="table-center-data">
                      <Button onClick={() => navigate("/chat")}>
                        <BsFillChatDotsFill color="#663399" size={20} />
                      </Button>
                    </td>
                    <td className="table-data">
                      <select
                        className="table-action-dropdown"
                        onChange={(e) => ActionHandler(e, tableValue.status)}
                      >
                        <option value="">Action</option>
                        <option value="View">View</option>
                      </select>
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <div className="table-pagination-main">
            <Stack spacing={2}>
              <Pagination count={10} variant="outlined" shape="rounded" />
            </Stack>
          </div>
        </div>
      </div>
    </SideMenu>
  );
};
export default Dispute;
